import axios from 'axios';

document.addEventListener('DOMContentLoaded', () => {
    // 获取元素
    const contactForm = document.getElementById('contactForm');
    const submitBtn = document.getElementById('submit-btn');
    const feedbackEl = document.getElementById('form-feedback');

    // 校验元素存在性
    if (!contactForm || !submitBtn || !feedbackEl) {
        console.warn('Form elements not found, check IDs!');
        return;
    }

    // 提交按钮点击事件
    submitBtn.addEventListener('click', async () => {
        // 1. 触发 Bootstrap 原生验证
        const isValid = contactForm.checkValidity();

        // 2. 更新验证样式（显示错误提示）
        contactForm.classList.add('was-validated');

        // 3. 验证失败则终止
        if (!isValid) {
            return;
        }

        // 4. 收集表单数据
        const formData = {
            name: document.getElementById('name').value.trim(),
            email: document.getElementById('email').value.trim(),
            company: document.getElementById('company').value.trim(),
            telephone: document.getElementById('telephone').value.trim(),
            message: document.getElementById('message').value.trim()
        };

        try {
            // 5. 提交前处理
            submitBtn.disabled = true;
            submitBtn.textContent = 'Submitting...';
            feedbackEl.classList.add('d-none'); // 隐藏之前的提示

            // 6. 发送请求
            // const response = await axios.post('https://www.ze-en.com/api/send-email', formData);
            // const response = await axios.post('http://192.168.92.131:8082/api/send-email', formData);
            const response = await axios.post('http://www.ze-en.com/api/send-email', formData);

            // 7. 提交成功反馈
            feedbackEl.className = 'alert alert-success'; // 成功样式
            feedbackEl.textContent = 'Submission successful! We will contact you soon.';
            feedbackEl.classList.remove('d-none');

            // 8. 重置表单和验证状态
            contactForm.reset();
            contactForm.classList.remove('was-validated');

        } catch (error) {
            // 9. 提交失败反馈
            feedbackEl.className = 'alert alert-danger'; // 失败样式
            feedbackEl.textContent = 'Submission failed! Please try again later.';
            feedbackEl.classList.remove('d-none');
            console.error('Form submission error:', error);

        } finally {
            // 10. 恢复按钮状态
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send Message';
        }
    });
});